import { Component, HostListener, inject, OnInit } from '@angular/core';
import { RouterLink, RouterLinkActive } from '@angular/router';
import { MegaMenuModule } from 'primeng/megamenu';
import { MenuModule } from 'primeng/menu';
import { AvatarModule } from 'primeng/avatar';
import { NgIcon } from '@ng-icons/core';
import { BadgeModule } from 'primeng/badge';
import { OverlayBadgeModule } from 'primeng/overlaybadge';
import { SIDEBAR_ITEMS } from '../../core/sidebar';
import { TranslatePipe } from '@ngx-translate/core';
import { APP_CONSTANTS } from '../../core/constants/constants';
import { AuthService } from '../../core/services/auth.service';
import { PopoverModule } from 'primeng/popover';
import { ButtonModule } from 'primeng/button';
import { LanguagePickerComponent } from '../language-picker/language-picker.component';
@Component({
  selector: 'app-sidebar',
  imports: [
    MegaMenuModule,
    RouterLink,
    RouterLinkActive,
    MenuModule,
    AvatarModule,
    NgIcon,
    BadgeModule,
    OverlayBadgeModule,
    TranslatePipe,
    PopoverModule,
    ButtonModule,
    LanguagePickerComponent,
  ],
  templateUrl: './sidebar.component.html',
  styleUrl: './sidebar.component.scss',
})
export class SidebarComponent implements OnInit {
  items = SIDEBAR_ITEMS;
  isMobile = false;
  authService = inject(AuthService);

  ngOnInit(): void {
    this.onResize();
  }

  @HostListener('window:resize', ['$event'])
  onResize() {
    this.isMobile = window.innerWidth < APP_CONSTANTS.UI.MOBILE_BREAKPOINT;
  }

  onLogout() {
    this.authService.logout();
  }
}
